import historyProvider from './historyProvider'
import symbolProvider from './symbols_database'


const supportedResolutions = ["1", "5", "15", "30", "60", "240", "1D","1W","1M"]
const symbols_types = ["Forex","Crypto"];
const config = {
    supported_resolutions: supportedResolutions,
    supports_marks:true,
    symbols_types:symbols_types
}; 

const lastBarsCache = new Map();
const globalRealtimeUpdator={};
let lastmarketTime = 0;
setTimeout(async()=>{
	const data = await makeApiRequest("getlastbar?symbol=EURUSD&resolution=1");
	if(data.time){
		lastmarketTime = data.time;
	}
},10);
setInterval(async()=>{
	if(globalRealtimeUpdator.symbolInfo){
		const data = await makeApiRequest("getlastbar?symbol="+globalRealtimeUpdator.symbolInfo.name+"&resolution="+globalRealtimeUpdator.resolution);
		if(data.time){
			const bar = {
				time:data.time*1000,
				open:data.open,
				high:data.high,
				low:data.low,
				close:data.close,
				volume:data.volume
			}		
			globalRealtimeUpdator.onRealtimeCallback(bar);
		}
	}
},2000)

async function makeApiRequest(path) {
	try {
		const url = `https://tradingview.fxtradium.asia/${path}`;
		const response = await fetch(url);
		return response.json();
	} catch (error) {
		throw new Error(`CryptoCompare request error: ${error.status}`);
	}
}
export default {
	onReady: cb => {
		setTimeout(() => cb(config), 0)
		
	},
	searchSymbols: (userInput, exchange, symbolType, onResultReadyCallback) => {

	    const newSymbols = symbolProvider.search(userInput,symbolType,exchange);
	    onResultReadyCallback(newSymbols);
	},
	resolveSymbol: (symbolName, onSymbolResolvedCallback, onResolveErrorCallback) => {

		var symbolInfo = symbolProvider.symbolInfo(symbolName);

		symbolInfo.has_intraday= true;
		symbolInfo.supported_resolution= supportedResolutions;
		symbolInfo.ticker = symbolInfo.name;
		symbolInfo.data_status='streaming';
		symbolInfo.minmov = 1;
		symbolInfo.minmov2 = 0;
		setTimeout(function() {
			onSymbolResolvedCallback(symbolInfo)
		}, 0)

	},
	getBars:async (symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) => {
		const { from, to, firstDataRequest } = periodParams;
		const urlParameters = {
			symbol: symbolInfo.name,
			resolution:resolution,
			from:from,
			to:to,
			limit:2000
		};
		const query = Object.keys(urlParameters)
			.map(name => `${name}=${encodeURIComponent(urlParameters[name])}`)
			.join('&');
		try {
			const data = await makeApiRequest(`getbars?${query}`);
			let bars = [];
			if(data.length==0 && from<lastmarketTime){
				onHistoryCallback([], {
					noData: true,
				});
			}
			data.forEach(bar => {
				if (bar.time >= from && bar.time < to) {
					bars = [...bars, {
						time: bar.time * 1000,
						low: bar.low,
						high: bar.high,
						open: bar.open,
						close: bar.close,
						volume:bar.volume
					}];
				}
			});
			if (firstDataRequest) {
				lastBarsCache.set(symbolInfo.name, {
					...bars[bars.length - 1],
				});
			}
			onHistoryCallback(bars, {
				noData: false,
			});
		} catch (error) {
			console.log('[getBars]: Get error', error);
			onErrorCallback(error);
		}},

	subscribeBars: (symbolInfo, resolution, onRealtimeCallback, subscribeUID, onResetCacheNeededCallback) => {
		globalRealtimeUpdator.onRealtimeCallback = onRealtimeCallback;
		globalRealtimeUpdator.symbolInfo = symbolInfo;
		globalRealtimeUpdator.resolution = resolution;
		
	},
	unsubscribeBars: subscriberUID => {
	},
	calculateHistoryDepth: (resolution, resolutionBack, intervalBack) => {
		//optional
		console.log('=====calculateHistoryDepth running')
		// while optional, this makes sure we request 24 hours of minute data at a time
		// CryptoCompare's minute data endpoint will throw an error if we request data beyond 7 days in the past, and return no data
		return resolution < 60 ? {resolutionBack: 'D', intervalBack: '1'} : undefined
	},
	getMarks: (symbolInfo, startDate, endDate, onDataCallback, resolution) => {
		//optional
		//console.log('========== getMarks running',{symbolInfo, startDate, endDate, onDataCallback, resolution})
		var lastMarkTimestamp = 1650240000;
		var day = 60 * 60 * 24;
		var marks = [
			{
				id: 0,
				time:lastMarkTimestamp - day * 4,
				color: "blue",
				text: "Red",
				label: "A",
				labelFontColor: "white",
				minSize: 14
			},
			{
				id: 1,
				time: lastMarkTimestamp - day * 7,
				color: "red",
				text: "Red",
				label: "A",
				labelFontColor: "white",
				minSize: 14
			},
		];
		onDataCallback(marks);
	},
	getTimeScaleMarks: (symbolInfo, startDate, endDate, onDataCallback, resolution) => {
		//optional
		console.log('=====getTimeScaleMarks running')
	},
	getServerTime: cb => {
		console.log('=====getServerTime running')
	}
}



// WEBPACK FOOTER //
// ./src/components/TVChartContainer/api/index.js